export const REQUIRED_FIELD_MESSAGE = 'Обязательное поле';
export const ERROR_PHONE_MESSAGE = 'Некорректный формат номера телефона';
export const MAX_PHONE_LENGTH = 17;
export const CORRECT_PHONE_LENGTH = 10;
